"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8947],{

/***/ 5734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1751);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3887);


// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin: 0px auto;\n  width: ",
        ";\n\n  &:before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 1.6s linear infinite;\n  height: 100%;\n  transform-origin: center center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  stroke: ",
        ";\n  stroke-width: 4;\n  stroke-miterlimit: 10;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  fill: none;\n  animation: ",
        " 1.2s ease-in-out infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 로딩
 * @param {object} props
 * @param {number} props.size
 * @param {string} props.color
 */ var SpinLoading = function(param) {
    var _size = param.size, size = _size === void 0 ? 36 : _size, _color = param.color, color = _color === void 0 ? cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.red040 */ .DG.red040 : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loader, {
        size: size,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "25 25 50 50",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CirclePath, {
                cx: "50",
                cy: "50",
                r: "20",
                color: color
            })
        })
    }));
};
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b538cb9d-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return "".concat(size, "px");
});
var Svg = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-b538cb9d-1"
})(_templateObject1(), lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .spin */ .O2);
var CirclePath = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].circle.withConfig */ .ZP.circle.withConfig({
    componentId: "sc-b538cb9d-2"
})(_templateObject2(), function(param) {
    var color = param.color;
    return color;
}, lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .dashLoad */ .tG);
/* harmony default export */ __webpack_exports__["Z"] = (SpinLoading);


/***/ }),

/***/ 9604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3887);


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: ",
        ";\n\n  & > div:first-child {\n    display: block;\n  }\n\n  & > div:last-child {\n    display: none;\n  }\n\n  ",
        " {\n    display: block;\n\n    & > div:first-child {\n      display: none;\n    }\n\n    & > div:last-child {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 상단 헤더 레이아웃 (Mobile, PC 구분)
 * @param {object} props
 * @param {JSX.Element} props.mobile
 * @param {JSX.Element} props.pc
 *
 * @example
 * <HeadLayout
 *   mobile={<Mobile_Header />}
 *   pc={<PC_Header />}
 * />
 */ var HeadLayout = function(param) {
    var mobile = param.mobile, pc = param.pc;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Layout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: mobile
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: pc
            })
        ]
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4f33893c-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .zIndex.header */ .W5.header, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.large */ .cy.large);
/* harmony default export */ __webpack_exports__["Z"] = (HeadLayout);


/***/ }),

/***/ 3349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var components_molecules_modal_search_AutoComplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7732);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6643);
/* harmony import */ var slices_search_thunk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7687);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8004);
/* harmony import */ var hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2567);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3887);




// components



// slices

// hooks


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  max-width: 640px;\n  height: 44px;\n  padding: 10px 20px;\n  border: ",
        ";\n  border-radius: 22px;\n  background-color: transparent;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  padding: 0 32px 0 0;\n  color: ",
        ";\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 48px;\n  top: 10px;\n\n  &:active {\n    & svg {\n      transition: fill 0.1s ease;\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 헤더 검색 Input
 * @param {object} props
 * @param {'Light' | 'Dark'} props.mode 모드
 */ var SearchInput = function(_param) {
    var _mode = _param.mode, mode = _mode === void 0 ? 'Light' : _mode, props = _objectWithoutProperties(_param, [
        "mode"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var keyword = router.query.keyword;
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I)();
    var autoCompletedClassList = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v)(function(state) {
        return state.search.autoCompletedKeywordList;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowAutoComplete = ref[0], setIsShowAutoComplete = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowErase = ref1[0], setIsShowErase = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), word = ref2[0], setWord = ref2[1];
    var searchRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var isSearched = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var throttle = (0,hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var onSearch = function() {
        if (!searchRef.current) {
            return;
        }
        var value = searchRef.current.value;
        value = value.replace(/#/g, '');
        router.push("/search?keyword=".concat(value));
    };
    var onAutoComplete = function(value) {
        setWord(value);
        dispatch((0,slices_search_thunk__WEBPACK_IMPORTED_MODULE_6__/* .postAutoCompleteKeyword */ .br)({
            keyword: value
        })).finally(function() {
            if (!isMounted.current) {
                return;
            }
            if (value.trim().length > 0 && !isSearched.current) {
                setIsShowAutoComplete(true);
                setIsShowErase(true);
            } else {
                setIsShowAutoComplete(false);
                setIsShowErase(false);
            }
        });
    };
    var onCloseAutoComplete = function() {
        setIsShowAutoComplete(false);
        setIsShowErase(false);
    };
    var onClear = function() {
        setIsShowAutoComplete(false);
        setIsShowErase(false);
        searchRef.current.value = '';
    };
    var onKeyPress = function(e) {
        if (e.key === 'Enter') {
            e.target.blur();
            onSearch();
            setIsShowAutoComplete(false);
            isSearched.current = true;
        } else {
            isSearched.current = false;
        }
    };
    var onChange = throttle.run(function(e) {
        var value = e.target.value;
        onAutoComplete(value);
    }, 400);
    var onFocus = function(e) {
        return window.setTimeout(function() {
            var value = e.target.value;
            isSearched.current = false;
            onAutoComplete(value);
        }, 100);
    };
    /** 초기화 작업 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        isSearched.current = false;
        isMounted.current = true;
        return function() {
            return isMounted.current = false;
        };
    }, []);
    /** 검색입력칸 값 변경 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (searchRef.current && keyword) {
            searchRef.current.value = keyword;
        }
    }, [
        keyword
    ]);
    /** 검색 후, 타 페이지 접속시 키워드 삭제하기 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (keyword) {
            return;
        }
        if (searchRef.current.value) {
            searchRef.current.value = '';
        }
    }, [
        keyword,
        searchRef
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Layout, {
        mode: mode,
        children: [
            isShowAutoComplete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_modal_search_AutoComplete__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                keyword: word,
                keywordList: autoCompletedClassList,
                onClose: onCloseAutoComplete
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({
                type: "text",
                placeholder: "무엇을 배우고 싶나요?",
                onFocus: onFocus,
                onKeyPress: onKeyPress,
                onChange: onChange,
                defaultValue: keyword,
                ref: searchRef,
                mode: mode
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchButton, {
                mode: mode,
                onClick: onSearch,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    name: "ic_search",
                    width: 24,
                    height: 24,
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey50 */ .DG.grey50
                })
            }),
            isShowErase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EraseButton, {
                width: 32,
                height: 22,
                onClick: onClear,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    name: "ic_close_circle_m",
                    width: 24,
                    height: 24,
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.BTN.BG */ .DG.BTN.BG
                })
            })
        ]
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df63f3d-0"
})(_templateObject(), function(param) {
    var mode = param.mode;
    return mode === 'Light' ? "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.system.grey */ .DG.system.grey) : "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.system.grey */ .DG.system.grey);
});
var Input = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-df63f3d-1"
})(_templateObject1(), function(param) {
    var mode = param.mode;
    return mode === 'Light' ? cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.white */ .DG.white;
}, function(param) {
    var mode = param.mode;
    return mode === 'Light' ? cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey0 */ .DG.grey0 : cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.font.tertiary2 */ .DG.font.tertiary2;
});
var SearchButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-df63f3d-2"
})(_templateObject2());
var EraseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-df63f3d-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey060 */ .DG.grey060);
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7379);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6643);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7732);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5549);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(506);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3887);



// components



// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 56px;\n\n  & > div:last-of-type {\n    height: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: inherit;\n  border-bottom: 1px solid ",
        ";\n  z-index: ",
        ";\n  box-sizing: content-box;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: inherit;\n  padding: 0 16px;\n  background-color: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  font-size: 0;\n\n  & > a {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  margin-left: 12px !important;\n  background-color: ",
        ";\n  border-radius: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 12px;\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex: 0 auto;\n\n  & > * ~ * {\n    margin-left: 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
/** 메인단 검색포함 헤더 */ var SigninMobileHeader = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Inner, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                name: "logo_white",
                                                width: 110,
                                                height: 20
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                name: "logo_symbol",
                                                width: 12,
                                                height: 13
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Service, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "".concat("https://www.classu.co.kr", "/search?keyword="),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchIcon, {
                                            as: "a",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                name: "ic_search",
                                                width: 20,
                                                height: 20,
                                                fill: cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.grey50 */ .DG.grey50
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "".concat("https://www.classu.co.kr", "/class/open"),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClassApplyButton, {
                                            as: "a",
                                            size: "32px",
                                            color: cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.BTN.BG */ .DG.BTN.BG,
                                            children: "클래스 개설"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        })
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-c762fe0f-0"
})(_templateObject());
var Header = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c762fe0f-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.system.grey */ .DG.system.grey, cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.header */ .W5.header);
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c762fe0f-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.system.BNB */ .DG.system.BNB, cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.header */ .W5.header);
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c762fe0f-3"
})(_templateObject3());
var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c762fe0f-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.BTN.BG */ .DG.BTN.BG);
var ClassApplyButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c762fe0f-5"
})(_templateObject5(), cds_typography__WEBPACK_IMPORTED_MODULE_5__/* .subtitle4_medium */ .b_, cds_styles__WEBPACK_IMPORTED_MODULE_6__/* .palette.grey50 */ .DG.grey50);
var Service = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c762fe0f-6"
})(_templateObject6());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c762fe0f-7"
})(_templateObject7());
/* harmony default export */ __webpack_exports__["Z"] = (SigninMobileHeader);


/***/ }),

/***/ 9072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7379);
/* harmony import */ var components_molecules_headers_SearchInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3349);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5549);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6643);
/* harmony import */ var components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6332);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3887);


// components




// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  height: 100%;\n  padding: 0 48px 0 36px;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 0;\n\n  & > a {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: none;\n  position: relative;\n\n  ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  & > button,\n  & > a:not(:first-child) {\n    margin-left: 8px;\n  }\n\n  ",
        " {\n    & > button,\n    & > a:not(:first-child) {\n      margin-left: 12px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          &::before {\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        &::before {\n          background-color: rgba(0, 0, 0, 0.04);\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px;\n  margin-right: 4px;\n  font-weight: 500;\n  font-size: 14px;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    &:hover {\n      ",
        ";\n    }\n  }\n\n  &:active {\n    ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
/** 메인 헤더 */ var SignPCHeader = function(_param) {
    var props = _extends({}, _param);
    var LeftSide = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftSideLayout, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: "/",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        name: "logo_white",
                        width: 110,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        name: "logo_symbol",
                        width: 12,
                        height: 13
                    })
                ]
            })
        })
    });
    var RightSide = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightSideLayout, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: "".concat("https://www.classu.co.kr", "/class/open"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClassOpenButton, {
                size: "32px",
                color: cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .palette.grey020 */ .DG.grey020,
                children: "클래스개설"
            })
        })
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({}, props, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                            children: LeftSide
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_headers_SearchInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                            children: RightSide
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_4__/* .HeaderBlank */ .m, {})
        ]
    }));
};
var ContentLayout = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d152884f-0"
})(_templateObject());
var Item = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d152884f-1"
})(_templateObject1());
var LeftSideLayout = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d152884f-2"
})(_templateObject2());
var RightSideLayout = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d152884f-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .mediaQuery.large */ .cy.large);
var ClassOpenButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d152884f-4"
})(_templateObject6(), cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .onlyHover */ .kC, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject4());
}, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject5());
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d152884f-5"
})(_templateObject7());
/* harmony default export */ __webpack_exports__["Z"] = (SignPCHeader);


/***/ })

}]);